import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Avatar,
  Badge,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";

import SettingsIcon from "@mui/icons-material/Settings";

import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

import SyncIcon from "@mui/icons-material/Sync";
import AddIcon from "@mui/icons-material/Add";

import axios from "axios";

const API = process.env.REACT_APP_API_URL;

/* ================================================
   HELPERS
================================================ */
function getDateBlock(dateStr) {
  if (!dateStr) return "OTROS";
  const date = new Date(dateStr);
  const now = new Date();

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const emailDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );

  const diff = (today - emailDay) / 86400000;

  if (diff === 0) return "HOY";
  if (diff === 1) return "AYER";
  if (diff < 7) return "ESTA SEMANA";

  const monthName = date.toLocaleString("es-ES", { month: "long" });
  if (date.getFullYear() === now.getFullYear()) return monthName;

  return `${monthName} ${date.getFullYear()}`;
}

function getBlockPriority(label) {
  const m = label.toLowerCase();
  if (m === "hoy") return 100000;
  if (m === "ayer") return 90000;
  if (m === "esta semana") return 80000;
  return 1000;
}

function accountColor(email) {
  if (!email) return "#999999";
  let hash = 0;
  for (let i = 0; i < email.length; i++) {
    hash = email.charCodeAt(i) + ((hash << 5) - hash);
  }
  const c = (hash & 0x00ffffff).toString(16).toUpperCase();
  return "#" + "000000".substring(0, 6 - c.length) + c;
}

function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const c = (hash & 0x00ffffff).toString(16).toUpperCase();
  return "#" + "000000".substring(0, 6 - c.length) + c;
}

function extractName(fromStr) {
  if (!fromStr) return null;

  // Si hay un nombre entre comillas o antes del <
  const match = fromStr.match(/^(.*?)(<|$)/);
  if (match) {
    const name = match[1].trim().replace(/(^")|("$)/g, "");
    if (name && !name.includes("@")) return name;
  }

  // Si no hay nombre, devolvemos el email tal cual
  const emailMatch = fromStr.match(/<(.*?)>/);
  return emailMatch ? emailMatch[1] : fromStr;
}

/* ================================================
   COMPONENTE
================================================ */
export default function EmailPanelIzquierdo({
  threads,
  selectedPerson,
  setSelectedPerson,
  search,
  setSearch,
  filter,
  setFilter,
  modoVista,
  setModoVista,
  setOpenAccounts,
  setShowSendPanel, // ADD
  accounts, // ADD
}) {
  const [anchorMenu, setAnchorMenu] = useState(null);

  const handleOpenMenu = (e) => setAnchorMenu(e.currentTarget);
  const handleCloseMenu = () => setAnchorMenu(null);

  /* ================= GROUPING ================= */
  const groupPeople = () => {
    const result = {};
    const s = search.toLowerCase();

    for (const threadKey in threads) {
      let mails = threads[threadKey];
      if (!mails.length) continue;

      // Último email
      const lastMail = mails[mails.length - 1];

      // Convertimos email → nombre real
      const [, contactEmail] = threadKey.split("::");
      const displayName = extractName(contactEmail) || contactEmail;

      // FILTRO DE BUSQUEDA
      if (s) {
        const matchesPerson = displayName.toLowerCase().includes(s);
        const matchesEmails = mails.some(
          (e) =>
            e.subject?.toLowerCase().includes(s) ||
            e.snippet?.toLowerCase().includes(s) ||
            e.from?.toLowerCase().includes(s)
        );
        if (!matchesPerson && !matchesEmails) continue;
      }

      if (filter === "read") mails = mails.filter((e) => e.isRead);
      if (filter === "unread") mails = mails.filter((e) => !e.isRead);
      if (!mails.length) continue;

      const sorted = [...mails].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
      const last = sorted[0];
      const block = getDateBlock(last.date);
      const unread = mails.filter((x) => !x.isRead).length;

      if (!result[block]) result[block] = [];

      // 🔥 Guardamos la clave real (email) + el nombre visible
      result[block].push({
        key: threadKey, // ← clave interna REAL
        name: displayName, // ← lo que se muestra al usuario
        unread,
        last,
      });
    }

    return Object.fromEntries(
      Object.entries(result).sort(
        ([a], [b]) => getBlockPriority(b) - getBlockPriority(a)
      )
    );
  };

  return (
    <Box
      sx={{
        width: 360,
        borderRight: "1px solid #e6e6e6",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#f7f8fa",
      }}
    >
      <Box sx={{ p: 2 }}>
        {/* TITLE */}

        <Box
          sx={{
            pt: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            /*  gap: 1, */
          }}
        >
          <Typography sx={{ fontSize: 22, fontWeight: 700 /* mb: 1 */ }}>
            MATRIX
          </Typography>
          <Box
            sx={{
              /* pt: 2, */
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Tooltip title="Opciones">
              <IconButton
                size="small"
                onClick={handleOpenMenu}
                sx={{ "&.MuiIconButton-root": { height: 35, width: 35 } }}
              >
                <SettingsIcon sx={{ fontSize: "1.5rem", color: "#000" }} />
              </IconButton>
            </Tooltip>

            <Tooltip title="New Email">
              <IconButton
                size="small"
                onClick={() => setShowSendPanel(true)}
                sx={{ "&.MuiIconButton-root": { height: 35, width: 35 } }}
              >
                <MarkEmailReadIcon
                  sx={{ fontSize: "1.5rem", color: "#69cbf9" }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* MENU DESPLEGABLE */}
        <Menu
          anchorEl={anchorMenu}
          open={Boolean(anchorMenu)}
          onClose={handleCloseMenu}
        >
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              setOpenAccounts(true);
            }}
          >
            <Button
              sx={{
                fontSize: 10,
                display: "flex",
                justifyContent: "flex-start",
                color: "#000",
                borderColor: "#000",
              }}
              variant="outlined"
              fullWidth
              startIcon={
                <AccountCircleOutlinedIcon
                /*   sx={{
                    color: "#69cbf9",
                  }} */
                />
              }
            >
              Cuentas
            </Button>
          </MenuItem>

          <MenuItem
            onClick={async () => {
              for (const acc of accounts) {
                await axios.get(`${API}/gmail/sync/${acc.email}`);
              }
            }}
          >
            <Button
              sx={{
                fontSize: 10,
                display: "flex",
                justifyContent: "flex-start",
                color: "#000",
                borderColor: "#000",
              }}
              variant="outlined"
              fullWidth
              startIcon={<SyncIcon />}
            >
              Sync
            </Button>
          </MenuItem>
          {/*  <MenuItem disableRipple> */}
          <Divider sx={{ marginLeft: 2, marginRight: 2 }} />
          <MenuItem
            onClick={() => {
              setModoVista("whatsapp");
              handleCloseMenu();
            }}
          >
            <Button
              sx={{
                fontSize: 10,
                display: "flex",
                justifyContent: "flex-start",
                color: "#000",
                borderColor: "#000",
              }}
              variant="outlined"
              fullWidth
              startIcon={
                <ChatBubbleOutlineOutlinedIcon
                  sx={{ color: modoVista === "whatsapp" ? "#25D366" : "#000" }}
                />
              }
            >
              Vista Chat
            </Button>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setModoVista("email");
              handleCloseMenu();
            }}
          >
            <Button
              sx={{
                fontSize: 10,
                display: "flex",
                justifyContent: "flex-start",
                color: "#000",
                borderColor: "#000",
              }}
              variant="outlined"
              fullWidth
              startIcon={
                <MailOutlineIcon
                  sx={{ color: modoVista === "email" ? "#25D366" : "#000" }}
                />
              }
            >
              Vista Email
            </Button>
          </MenuItem>
        </Menu>

        {/* 🟦 BOTONES NUEVO / SYNC / CUENTAS — REINSERTADOS */}

        {/* BUSCADOR */}
        <TextField
          fullWidth
          placeholder="Buscar…"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mt: 2 }}
        />

        {/* FILTROS */}
        <ToggleButtonGroup
          value={filter}
          exclusive
          onChange={(e, v) => v && setFilter(v)}
          sx={{
            mt: 1,
            width: "100%",
            "& .MuiToggleButton-root": { padding: "2px !important" },
          }}
        >
          <ToggleButton
            value="all"
            sx={{ fontSize: 8, flex: 1, fontWeight: 700 }}
          >
            Todos
          </ToggleButton>
          <ToggleButton
            value="unread"
            sx={{ fontSize: 8, flex: 1, fontWeight: 700 }}
          >
            No leídos
          </ToggleButton>
          <ToggleButton
            value="read"
            sx={{ fontSize: 8, flex: 1, fontWeight: 700 }}
          >
            Leídos
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* LISTA DE PERSONAS */}
      <Box sx={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
        {Object.entries(groupPeople()).map(([block, people]) => (
          <React.Fragment key={block}>
            <Box
              sx={{
                px: 2,
                py: 1,
                bgcolor: "#eceff4",
                position: "sticky",
                top: 0,
                zIndex: 5,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: 10,
                  color: "#555",
                  textTransform: "uppercase",
                }}
              >
                {block}
              </Typography>
            </Box>

            <List disablePadding>
              {people.map(({ key, name, unread, last }) => (
                <ListItemButton
                  key={key}
                  selected={selectedPerson === key}
                  onClick={() => setSelectedPerson(key)}
                  sx={{ py: 1, borderBottom: "1px solid #f0f0f0" }}
                >
                  <Box sx={{ position: "relative", mr: 1 }}>
                    <Box
                      sx={{
                        position: "absolute",
                        top: -5,
                        left: 0,
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: accountColor(last.accountEmail),
                        border: "2px solid white",
                        zIndex: 5,
                      }}
                    />
                    <Avatar
                      sx={{
                        bgcolor: stringToColor(name),
                        width: 35,
                        height: 35,
                      }}
                    >
                      {name.charAt(0).toUpperCase()}
                    </Avatar>
                  </Box>

                  <ListItemText
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontWeight: 800,
                        fontSize: 12,
                      },
                      "& .MuiListItemText-secondary": {
                        fontSize: 11,
                        color: "#666",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                        mr: 2,
                      },
                    }}
                    primary={name} // ← SE MUESTRA EL NOMBRE
                    secondary={
                      last.snippet
                        ? last.snippet.slice(0, 55) + "…"
                        : last.subject
                    }
                  />

                  {unread > 0 && (
                    <Badge
                      badgeContent={unread}
                      sx={{
                        "& .MuiBadge-badge": { backgroundColor: "#69cbf9" },
                      }}
                    />
                  )}
                </ListItemButton>
              ))}
            </List>
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
}
